import { render, staticRenderFns } from "./Redemption.vue?vue&type=template&id=2942d4c3"
import script from "./Redemption.vue?vue&type=script&lang=js"
export * from "./Redemption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports